<template>
  <div class="container client">
    <div class="header card">
      <el-breadcrumb
        class="breadcrumb"
        separator="/"
      >
        <el-breadcrumb-item>分销</el-breadcrumb-item>
        <el-breadcrumb-item>推广学员</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">推广学员</h2>
        </div>
        <div class="right">
        </div>
      </div>
    </div>
    <div class="filters card">
      <el-form
        class="search-wrap"
        ref="searchForm"
        :inline="true"
        :model="query"
      >
        <el-form-item label="用户信息">
          <el-input
            v-model.trim="query.stdudent_keyword"
            placeholder="请输入学生用户 id/姓名/手机号"
            @input="searchSetTimeout()"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="邀请人">
          <el-input
            v-model.trim="query.referrer_senior_keyword"
            placeholder="请输入学长 id/学长姓名/学长昵称"
            @input="searchSetTimeout()"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="报考年份">
          <el-select
            v-model="query.apply_years"
            multiple
            collapse-tags
            clearable
            placeholder="请选择报考年份"
            @change="fetchList(true)"
          >
             <el-option label="2027" value="2027"></el-option>
            <el-option label="2026" value="2026"></el-option>
            <el-option label="2025" value="2025"></el-option>
            <el-option label="2024" value="2024"></el-option>
            <el-option label="2023" value="2023"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select
            v-model="query.statuses"
            multiple
            collapse-tags
            clearable
            placeholder="请选择"
            @change="fetchList(true)"
          >
            <el-option
              v-for="item in filter.statuses"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="确认状态">
          <el-select
            v-model="query.confirm_statuses"
            clearable
            placeholder="请选择"
            @change="fetchList(true)"
          >
            <el-option
              label="未确认"
              :value="0"
            >
            </el-option>
            <el-option
              label="确认有效"
              :value="1"
            >
            </el-option>
            <el-option
              label="确认无效"
              :value="2"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="下单时间">
          <el-date-picker
            class="datetime"
            v-model="expire_time"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            clearable
            @change="fetchList(true)"
            :default-time="['00:00:00', '23:59:59']"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
    </div>

    <div class="results card">
      <div class="values-header">
        <p class="title">学员列表</p>
      </div>
      <div class="values">
        <el-table
          class="table"
          :data="results"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="id"
            label="ID"
            width="80"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="student_name"
            label="考研年份"
            min-width="160"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.apply_year?`${scope.row.apply_year}年`:'无' }}
            </template>
          </el-table-column>
          <el-table-column
            prop="student_name"
            label="姓名"
            min-width="160"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="student_mobile"
            label="手机号"
            min-width="160"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="student_name"
            label="报考信息"
            min-width="350"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.apply_college_code&&scope.row.apply_college_name">{{ scope.row.apply_college_name }}</span>
              <span v-if="scope.row.apply_academy_code&&scope.row.apply_academy_name"> | {{ scope.row.apply_academy_name }}</span>
              <span v-if="scope.row.apply_major_code&&scope.row.apply_major_name"> | （{{ scope.row.apply_major_code }}）{{ scope.row.apply_major_name }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="学长信息"
            min-width="200"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.referrer_senior_id">{{ scope.row.referrer_senior_id }}</span>
              <span v-if="scope.row.referrer_senior_user_realname"> | {{ scope.row.referrer_senior_user_realname }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="consult_manage_name"
            label="咨询师"
            width="150"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            label="状态"
            width="100"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div @click="handleToStatus(scope.row)">
                <el-tag
                  type="warning"
                  size="mini"
                  v-if="scope.row.status==0"
                >待跟进</el-tag>
                <el-tag
                  size="mini"
                  v-if="scope.row.status==1"
                >已跟进</el-tag>
                <el-tag
                  size="mini"
                  type="success"
                  v-if="scope.row.status==2"
                >已报名</el-tag>
                <el-tag
                  size="mini"
                  type="info"
                  v-if="scope.row.status==3"
                >未报名</el-tag>
                <el-tag
                  size="mini"
                  type="danger"
                  v-if="scope.row.status==4"
                >已失效</el-tag>
                <el-tag
                  size="mini"
                  v-if="scope.row.status==5"
                >结佣中</el-tag>
                <el-tag
                  size="mini"
                  type="success"
                  v-if="scope.row.status==6"
                >已结佣</el-tag>
              </div>

            </template>
          </el-table-column>
          <el-table-column
            label="创建时间"
            width="150"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ $moment(scope.row.create_time).format("YYYY.MM.DD HH:mm") }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="失效时间"
            width="150"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ $moment(scope.row.expire_time).format("YYYY.MM.DD HH:mm") }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="100"
            align="center"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="text"
                @click="handleToEdit(scope.row)"
              >编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination
          background
          layout="total, prev, pager, next, sizes, jumper"
          :current-page="Number(query.pageIndex)"
          :page-sizes="[10, 20, 50, 100, 500]"
          :page-size="Number(query.pageSize)"
          :total="Number(pageTotal)"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>
    <RecommendEdit
      :id="editId"
      :isVisible="editDialog"
      @close="editDialog=false"
      @submit="fetchList(true)"
    ></RecommendEdit>
    <RecommendStatus
      :id="editId"
      :isVisible="statusDialog"
      @close="statusDialog=false"
      @submit="fetchList(true)"
    ></RecommendStatus>
  </div>
</template>
  
  <script>
import { seniorStudentList } from "@/api/distribution";

import RecommendEdit from "@/components/dialog/distribution/RecommendEdit.vue";
import RecommendStatus from "@/components/dialog/distribution/RecommendStatus.vue";


let Timer = null       // 定时器
let TimerTime = 1000    // 定时器 等待时长

export default {
  components: {
    RecommendEdit,
    RecommendStatus
  },
  data() {
    return {
      query: {
        pageIndex: 1,
        pageSize: localStorage.getItem("pageSize")
          ? Number(localStorage.getItem("pageSize"))
          : 10,
        isPaging: 1,
      },
      pageTotal: 10,
      results: [],
      filter: {
        statuses: [
          { value: '0', label: '待跟进' },
          { value: '1', label: '已跟进' },
          { value: '2', label: '已报名' },
          { value: '3', label: '未报名' },
          { value: '4', label: '已失效' },
          { value: '5', label: '结佣中' },
          { value: '6', label: '已结佣' },
        ]
      },
      editDialog: false,
      editId: null,
      statusDialog: false,
      expire_time: "",


    };
  },
  created() {
    this.parseQuery()
    this.fetchList();

    this.$store.dispatch("getAllColleges");


  },
  watch: {
    // 时间数据监听
    expire_time(value) {
      console.log(value);
      if (value) {
        this.query.start_expire_time = this.$moment(value[0]).valueOf();
        this.query.end_expire_time = this.$moment(value[1]).valueOf();
      } else {
        this.query.start_expire_time = "";
        this.query.end_expire_time = "";
        this.fetchList(true)
      }
    },
  },
  methods: {
    fetchList(isReset = false) {
      if (isReset) {
        this.$set(this.query, "pageIndex", 1);
      }

      const params = Object.assign({}, this.query);
      if (params.apply_years) {
        params.apply_years = params.apply_years.filter((v) => v).join(",");
      }
      if (params.statuses) {
        params.statuses = params.statuses.filter((v) => v).join(",");
      }
      console.log(params);

      seniorStudentList(params).then((res) => {
        this.results = res.list || [];
        this.pageTotal = res.count;
      });
      this.syncQuery();
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, "pageSize", val);
      localStorage.setItem("pageSize", val);
      this.fetchList();
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, "pageIndex", val);
      this.fetchList();
    },
    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach((key) => {
        this.query[key] = this.$route.query[key];
      });
      if (this.query.apply_years) {
        this.query.apply_years = this.query.apply_years.split(",");
      }
      if (this.query.statuses) {
        this.query.statuses = this.query.statuses.split(",");
      }
      if (this.query.start_expire_time && this.query.end_expire_time) {
        this.expire_time = [
          this.$moment(Number(this.query.start_expire_time)),
          this.$moment(Number(this.query.end_expire_time)),
        ];
      }
    },
    // 同步URL请求参数
    syncQuery() {
      let isSync = Object.keys(this.query).some(
        (key) => this.$route.query[key] != this.query[key]
      );
      const params = Object.assign({}, this.query);

      if (params.apply_years) {
        params.apply_years = params.apply_years.filter((v) => v).join(",");
      }
      if (params.statuses) {
        params.statuses = params.statuses.filter((v) => v).join(",");
      }
      isSync &&
        this.$router.replace({
          query: Object.assign({}, this.$route.query, this.query),
        });
    },
    handleToEdit(row) {
      this.editId = row.id
      this.editDialog = true
    },
    handleToStatus(row) {

      this.editId = row.id
      this.statusDialog = true

    },
    searchSetTimeout() {
      clearTimeout(Timer)
      Timer = setTimeout(() => {
        this.fetchList(true)
      }, TimerTime)
    },
  },
};
  </script>
  
  <style scoped lang="less">
.client {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
      overflow-y: visible;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
  .el-link {
    font-size: 14px;
    margin: 0px 5px;
  }
}
</style>
  